import { QUERIES_INFO } from '@shared';
import type { AxiosResponse } from 'axios';
import type { QueryClient } from 'react-query';
import type { TGetCurrentUserMappedData } from '@entities/user/api/useGetCurrentUser';
import type { TUser } from '@entities/user/lib/types';
import type { TUseUploadAvatarResponse } from './types';
type TUpdateQueryUserDataArgs = {
  responseData: AxiosResponse<TUseUploadAvatarResponse>;
  queryClient: QueryClient;
  uuid?: TUser['id'];
};
export const onSuccessAvatarChange = ({
  responseData,
  queryClient,
  uuid
}: TUpdateQueryUserDataArgs) => {
  const queryKey = uuid ? [QUERIES_INFO.user.key, uuid] : [QUERIES_INFO.currentUser.key];
  queryClient.setQueryData<TGetCurrentUserMappedData | undefined>(queryKey, prevUserData => {
    if (!prevUserData) return prevUserData;
    return {
      ...prevUserData,
      avatar: responseData.data
    };
  });
};